import {
	saveDataInLFStorage,
	getDataFromLFStorage,
	removeDataFromLFStorage,
} from "../../../services/storage/LFStorage";


export class DeviceStorage {
	/**
	 * Save a key-value pair
	 * @param  {String} key The key
	 * @param  {Any} obj The value to save
	 * @return {Promise} Resolves with the saved object
	 */
	async save(key, obj) {
		await saveDataInLFStorage(key, obj);
		return obj;
	}

	/**
	 * Update the value in the store for a given key
	 * @param  {String} key The key
	 * @param  {Any} value The value to update with
	 * @return {Promise} Resolves with the updated value
	 */
	async update(key, value) {
		return this.save(key, value);
	}

	/**
	 * Get the value for a key
	 * @param {String} key The key
	 * @return {Promise} Resolves with the stored value
	 */
	async get(key) {
		try {
			const value = await getDataFromLFStorage(key);
			return value || null;
		} catch (error) {
			console.error("Error getting data from device storage", error);
			throw error;  // Re-throw to ensure the caller can handle the error
		}
	}

	/**
	 * Removes the value and key
	 * @param  {String} key The key to remove
	 * @return {Promise} Resolves when the key is removed
	 */
	async delete(key) {
		await removeDataFromLFStorage(key);
	}

	// The following array-related methods are currently unused and can be removed or implemented as needed.

	// async getArrayValues(key) {
	//   // Logic for retrieving array values
	// }

	// async saveArrayValue(key, val) {
	//   // Logic for saving an array value
	// }

	// async saveArrayValues(key, values) {
	//   // Logic for saving multiple array values
	// }

	// async removeArrayValue(key, val) {
	//   // Logic for removing an array value
	// }

	// async removeAllArrayValues(key) {
	//   // Logic for removing all array values
	// }
}
